import script from "./RecoveryRefusedOrderShowPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./RecoveryRefusedOrderShowPayment.vue?vue&type=script&setup=true&lang=js"

import "./RecoveryRefusedOrderShowPayment.vue?vue&type=style&index=0&id=30918012&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30918012"]])

export default __exports__